import { Component, Input, OnInit } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { LocaleService } from '../../service/locale.service';

@UntilDestroy()
@Component({
  selector: 'app-empty',
  templateUrl: './empty.component.html',
  styleUrls: ['./empty.component.scss'],
})
export class EmptyComponent implements OnInit {
  @Input() text: string = this.localeService.getValue('no_record');
  @Input() icon: string = 'assets/svg/data-empty.png';
  @Input() iconWidth?: string;
  @Input() smallText: boolean = false;

  constructor(private localeService: LocaleService) {}

  ngOnInit() {}
}
